// Reads the achievement tracks. The endpoint is audience-aware (progress when
// signed in, live tracks at zero for guests), so the query is keyed by user id
// and waits for auth to settle. For a signed-in user the account socket keeps
// the cached tracks current (AchievementContext), so they never go stale; the
// fetch only fills a cache the socket has not written yet.

import { useQuery } from '@tanstack/react-query';
import { getAchievementProgress } from '../transport/api/publicApi';
import { useAuth } from './useAuth';

export const achievementTracksQueryKey = (userId: string | undefined) =>
  ['achievements', userId ?? 'guest'] as const;

export const fetchAchievementTracks = async () =>
  (await getAchievementProgress()).data.tracks;

export function useAchievementTracks() {
  const { user, isAuthInitialized } = useAuth();

  return useQuery({
    queryKey: achievementTracksQueryKey(user?._id),
    queryFn: fetchAchievementTracks,
    enabled: isAuthInitialized,
    staleTime: user ? Infinity : undefined,
  });
}
